module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    },
    on: {
      "after-enter": function($event) {
        _vm.$emit('transitionEnd', this)
      }
    }
  }, [(_vm.loadingText && _vm.isLoading) ? _c('div', [_c('yz-spinner', {
    key: "spinner",
    staticClass: "center",
    attrs: {
      "color": "#1b90f5"
    }
  }), _vm._v(" "), (_vm.loadingText) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.loadingText))]) : _vm._e()], 1) : (_vm.isLoading) ? _c('yz-spinner', {
    key: "spinner",
    staticClass: "centered",
    attrs: {
      "color": "#1b90f5"
    }
  }) : (_vm.showError && _vm.task.error) ? _c('div', {
    staticClass: "error-container text-center"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('errorView.title')))]), _vm._v(" "), _c('article', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), (_vm.canRetry) ? _c('p', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.retry($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('errorView.tryAgain')))])]) : _vm._e()])]) : (_vm.$slots.default) ? _c('div', {
    key: "main"
  }, [_vm._t("default")], 2) : (_vm.$slots.root) ? _vm._t("root") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eed05e42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/TaskLoading.vue
// module id = 548
// module chunks = 2